import React from 'react';

export interface ContextProps {
    scrollContent: ((scrollDistance: number) => void) | null;
    scrollStep: number | null;
    setContentRef: ((ref: HTMLElement | null, itemRefs: HTMLElement[]) => void) | null;
}

const contextValue: ContextProps = {
    scrollContent: null,
    scrollStep: null,
    setContentRef: null,
};

export const CarouselContext = React.createContext(contextValue);
